import React from "react";

export default function NotFoundPage() {
  return <div>NotFoundPage</div>;
}
